module.exports = __webpack_public_path__ + "img/strategy-gmbh-logo.df935143.png";